import type {
  FindResult,
  MetricNameV2,
} from "schemas/generated/analyticsApiV2";

import * as React from "react";

import MetricWithDelta from "@editor/components/analytics/MetricWithDelta";
import { calculateDelta } from "@editor/utils/analytics";

type MetricsOverviewProps = {
  mainFindResults: FindResult[];
  compareFindResults: FindResult[];
  isLoading: boolean;
};

/**
 * TODO (Max, 2025-04-23, INS-684): Harcoding these for now. Once we'll have DMV2 available, we'll
 * add the real values from Clickhouse
 */
export const MetricsOverview: React.FC<MetricsOverviewProps> = ({
  mainFindResults,
  compareFindResults,
  isLoading,
}) => {
  const mainFindResult = mainFindResults[0];

  if (isLoading) {
    return <div>loading...</div>;
  }

  const metricsCards: {
    key: MetricNameV2;
    label: string;
  }[] = [
    {
      key: "purchase_amt",
      label: "Total Revenue",
    },
    {
      key: "purchases",
      label: "Total Purchases",
    },
    {
      key: "sessions",
      label: "Unique Sessions",
    },
    {
      key: "rate_purchases",
      label: "Conversion Rate",
    },
    {
      key: "average_order_value",
      label: "Average Order Value",
    },
    {
      key: "revenue_per_session",
      label: "Revenue Per Session",
    },
  ];

  if (!mainFindResult) {
    return null;
  }

  return (
    <div className="grid grid-cols-6 gap-4">
      {metricsCards.map((metricCard) => {
        const { key, label } = metricCard;

        const mainValues = mainFindResult.metrics[key];
        const mainValue = mainValues?.[0];

        const compareValues = compareFindResults[0]?.metrics[key];
        const compareValue = compareValues?.[0];
        const doesCompareValueExist = compareValue != undefined;

        return (
          <div
            key={key}
            className="border-secondary flex flex-col gap-1 rounded-lg border px-2 py-3"
          >
            <span className="text-sm">{label}</span>
            <MetricWithDelta
              name={key}
              value={mainValue ?? null}
              delta={calculateDelta(mainValue, compareValue)}
              doesCompareValueExist={doesCompareValueExist}
              wrapperClassName="block space-y-1"
              valueClassName="font-semibold"
            />
          </div>
        );
      })}
    </div>
  );
};
